import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  PostNumberCity,
  PostNumberEntity,
  PostNumberError,
} from "./postNumberInterfaces";

const initialState: PostNumberEntity = {
  isLoading: false,
  error: null,
  current: null,
};

const postNumberSlice = createSlice({
  name: "postNumber",
  initialState,
  reducers: {
    fetchCityStart: (state, _action: PayloadAction<string>) => {
      state.isLoading = true;
    },
    fetchCitySuccess: (state, action: PayloadAction<PostNumberCity>) => {
      state.current = action.payload;
      state.isLoading = false;
    },
    fetchCityFailed: (state, action: PayloadAction<PostNumberError>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { fetchCityStart, fetchCitySuccess, fetchCityFailed } =
  postNumberSlice.actions;
export const postNumber = postNumberSlice.reducer;
